var React = require('react');

function AddButtonInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.99765 4.50003V9.50112M9.4982 7.00058H4.4971M12.999 7.00058C12.999 3.68735 10.3109 0.999268 6.99765 0.999268C3.68443 0.999268 0.996338 3.68735 0.996338 7.00058C0.996338 10.3138 3.68443 13.0019 6.99765 13.0019C10.3109 13.0019 12.999 10.3138 12.999 7.00058Z","stroke":"black","strokeWidth":"1.00189","strokeLinecap":"round"}));
}

AddButtonInline.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = AddButtonInline;

AddButtonInline.default = AddButtonInline;
